import { render } from "./HotelBooking.vue?vue&type=template&id=6144e7dc&scoped=true"
import script from "./HotelBooking.vue?vue&type=script&lang=js"
export * from "./HotelBooking.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=6144e7dc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6144e7dc"]])

export default __exports__